import request from '@/utils/request'

let Team_award_logApi = {

  /*团队奖记录列表*/
  list(data) {
    return request._post('/shop/plus.team_award_log.Index/index', data);
},
/*添加团队奖记录*/
add(data) {
    return request._post('/shop/plus.team_award_log.Index/add', data);
},
/*修改团队奖记录*/
edit(data) {
    return request._post('/shop/plus.team_award_log.Index/edit', data);
},
/*删除团队奖记录*/
del(data) {
    return request._post('/shop/plus.team_award_log.Index/del', data);
},
/*团队奖记录详情*/
detail(data) {
  return request._post('/shop/plus.team_award_log.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.team_award_log.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.team_award_log.Setting/getSetting', data, errorback);
    },
}
export default Team_award_logApi;



// WEBPACK FOOTER //
// ./src/api/team_award_log.js